import { render, staticRenderFns } from "./sam-home.vue?vue&type=template&id=0aca8512"
import script from "./sam-home.vue?vue&type=script&lang=js"
export * from "./sam-home.vue?vue&type=script&lang=js"
import style0 from "./sam-home.vue?vue&type=style&index=0&id=0aca8512&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports